/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ArticleViewClientIdShortCodeLanguageCodeGet$Params {
  clientId: string;
  shortCode: string;
  languageCode: string;
}

export function articleViewClientIdShortCodeLanguageCodeGet(http: HttpClient, rootUrl: string, params: ArticleViewClientIdShortCodeLanguageCodeGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, articleViewClientIdShortCodeLanguageCodeGet.PATH, 'get');
  if (params) {
    rb.path('clientId', params.clientId, {});
    rb.path('shortCode', params.shortCode, {});
    rb.path('languageCode', params.languageCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as MediaStrictHttpResponse<void>;
    })
  );
}

articleViewClientIdShortCodeLanguageCodeGet.PATH = '/Article/View/{clientId}/{shortCode}/{languageCode}';
